import styled from 'styled-components'
import colors from '../../data/color-pallette'

export const Title = styled.h1`
  font-weight: bold;
  color: ${colors.heading};
  margin: 0;
  white-space: normal;
`
